'use client'

import * as React from 'react'
import { useRef } from 'react'
import Image from 'next/image'
import { useMediaQuery } from '@segway/core'

import { Carousel, CarouselItem } from '@/components'
import { Link } from '@/i18n/navigation'
import { type CarouselApi } from '@/ui/carousel/Carousel'

import { CategoryDataType } from '../types'

interface CategoryProps {
  blockData: CategoryDataType
}
const Category = ({ blockData }: CategoryProps) => {
  const responsive = useMediaQuery()
  const carouselRef = useRef<CarouselApi>(null)
  const carouselNotScroll =
    !carouselRef.current?.canScrollNext() && !carouselRef.current?.canScrollPrev()

  return blockData?.categories && blockData?.categories?.length > 0 ? (
    <div className="flex w-full items-center justify-center max-xl:justify-start">
      <div className={`w-full overflow-hidden`}>
        <div className="pt-[24px] max-xl:w-full max-xl:justify-start max-xl:pb-1 max-xl:pt-[8px]">
          <div className="hidden sm:block">
            <Carousel
              ref={carouselRef}
              autoPlay={false}
              showIndicators={false}
              showArrows={responsive && responsive.xl ? true : false}
              arrowIconDisableClassName="hidden"
              carouselContentClassName={carouselNotScroll ? 'justify-center' : ''}
              className="w-full"
              options={{ dragFree: responsive && responsive.xl ? false : true }}>
              {blockData.categories.map((category, index) => (
                <CarouselItem
                  key={index}
                  className={`mr-[20px] w-fit basis-auto xl:mr-[56px] ${!carouselNotScroll && index === 0 ? 'ml-[16px] xl:ml-7 2xl:ml-[calc((100%-1440px)/2)]' : ''} ${index === 0 ? 'max-xl:ml-[16px]' : ''} last:mr-[16px] last:xl:mr-0`}>
                  <Link
                    className={`group flex shrink-0 flex-col items-center justify-center max-xl:w-fit`}
                    href={category?.link}>
                    <Image
                      className="h-[100px] w-[100px] duration-300 max-xl:h-[64px] max-xl:w-[64px] group-hover:lg:scale-110"
                      src={`${category?.icon}`}
                      alt={`${category?.image_alt}`}
                      width={100}
                      height={100}
                      style={{ objectFit: 'cover' }}
                    />
                    <p className="mt-[4px] font-miSansDemiBold450 text-[14px] leading-[1.4] max-xl:mt-[2px] max-xl:text-[10px] group-hover:lg:text-[#DA291C]">
                      {category?.title}
                    </p>
                  </Link>
                </CarouselItem>
              ))}
            </Carousel>
          </div>
          <div className="sm:hidden">
            <div className="overflow-hidden pl-[10px]">
              <div className="horizontal-scrollable-container">
                <div className="m-auto flex w-fit gap-[9px]">
                  {blockData.categories.map((category, index) => (
                    <div
                      key={index}
                      style={{ minWidth: '64px' }}
                      className={`inline-block ${index === blockData?.categories?.length - 1 ? 'pr-[10px]' : ''}`}>
                      <Link
                        className="group flex flex-col items-center justify-center no-underline"
                        href={category?.link}>
                        <Image
                          className="h-[100px] w-[100px] duration-300 max-xl:h-[64px] max-xl:w-[64px]"
                          src={category?.icon}
                          alt={category?.image_alt}
                          width={100}
                          height={100}
                        />
                        <div className="mt-[2px] h-[14px] overflow-hidden leading-none">
                          <p className="origin-top scale-[0.83] transform whitespace-nowrap font-miSansDemiBold450 text-[12px] leading-none">
                            {category?.title}
                          </p>
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null
}

export default Category
